import apiClient from '../utils/api';
import { getIdToken } from '../utils/auth';

export const adminService = {
  /**
   * Get list of all users
   */
  async getUsers(limit = 50, offset = 0) {
    const response = await apiClient.get(`/admin/users?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  /**
   * Get detailed user information
   */
  async getUserDetails(userId) {
    const response = await apiClient.get(`/admin/user/${userId}`);
    return response.data;
  },

  /**
   * Analyze user engagement patterns
   */
  async analyzeEngagement(userId) {
    const response = await apiClient.post('/admin/analyze-engagement', {
      user_id: userId
    });
    return response.data;
  },

  /**
   * Send engagement message to user
   */
  async sendMessage(userId, message) {
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('message', message);
    
    const response = await apiClient.post('/admin/send-message', formData);
    return response.data;
  },

  /**
   * Start engagement analysis for a user
   */
  async analyzeEngagement(userId) {
    const response = await apiClient.post('/admin/analyze-engagement', {
      user_id: userId
    });
    return response.data;
  },

  /**
   * Get all engagement analyses for a user
   */
  async getUserAnalyses(userId, limit = 10) {
    const response = await apiClient.get(`/admin/engagement-analyses/${userId}?limit=${limit}`);
    return response.data;
  },

  /**
   * Get a specific engagement analysis
   */
  async getAnalysis(userId, analysisId) {
    const response = await apiClient.get(`/admin/engagement-analysis/${userId}/${analysisId}`);
    return response.data;
  },

  /**
   * Get user tab data (conversations, tasks, calendar, reminders, config)
   * For conversations, accepts optional pagination params: { page_size, last_key }
   */
  async getUserTabData(userId, tab, params = {}) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null))
    ).toString();
    const url = queryString
      ? `/admin/user/${userId}/${tab}?${queryString}`
      : `/admin/user/${userId}/${tab}`;
    const response = await apiClient.get(url);
    return response.data;
  },
};
